import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

export default function Header({ lang, setLang }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const t = {
    login: lang === 'de' ? 'Anmelden' : 'Login',
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 bg-white transition-shadow duration-300 ${
        scrolled ? 'shadow-md' : 'shadow-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a href="/" className="flex items-center gap-1 select-none">
            <span className="text-2xl font-black tracking-tight text-emerald-600">
              FitX
            </span>
            <span className="text-2xl font-black tracking-tight text-slate-900">
              celerate
            </span>
          </a>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-4">
            {/* Language toggle */}
            <button
              onClick={() => setLang(lang === 'de' ? 'en' : 'de')}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-slate-200 text-sm font-medium text-slate-600 hover:border-emerald-500 hover:text-emerald-600 transition-all duration-200"
            >
              <span className="text-base">{lang === 'de' ? '🇨🇭' : '🇬🇧'}</span>
              <span>{lang === 'de' ? 'DE' : 'EN'}</span>
            </button>

            {/* Login */}
            <a
              href="/s"
              className="px-5 py-2 rounded-lg border-2 border-emerald-600 text-emerald-600 font-semibold text-sm hover:bg-emerald-600 hover:text-white transition-all duration-200"
            >
              {t.login}
            </a>
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden p-2 rounded-lg text-slate-600 hover:text-emerald-600 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-slate-100 px-4 py-4 flex flex-col gap-3">
          <button
            onClick={() => {
              setLang(lang === 'de' ? 'en' : 'de');
              setMobileOpen(false);
            }}
            className="flex items-center gap-2 px-3 py-2 rounded-lg border border-slate-200 text-sm font-medium text-slate-600 w-fit"
          >
            <span>{lang === 'de' ? '🇨🇭' : '🇬🇧'}</span>
            <span>{lang === 'de' ? 'DE → EN' : 'EN → DE'}</span>
          </button>
          <a
            href="/s"
            className="px-5 py-2.5 rounded-lg border-2 border-emerald-600 text-emerald-600 font-semibold text-sm text-center hover:bg-emerald-600 hover:text-white transition-all duration-200"
          >
            {t.login}
          </a>
        </div>
      )}
    </header>
  );
}
